import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  NavBar,
  LoaderIndicator,
  HelperViewStatus,
  Heading,
  HeadingDisplay,
  Grid,
  ButtonBoxDecide
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { ObjectiveCard } from './components/ObjectiveCard';
import { WalletCard } from './components/WalletCard';
import { getCatalog, ICatalog } from '@/modules/catalog/services/catalog';
import { useCatalogStore } from '@/modules/catalog/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Catalog',
  props: {
    renderAsView: { type: Boolean, default: true },
    routeInvestmentGuard: { type: Function, default: () => {} }
  },
  setup(__props: any) {

const props = __props as { renderAsView: boolean, routeInvestmentGuard: () => void };

const router = useRouter();
const route = useRoute();



const catalog = ref<ICatalog | null>(null);
const isLoading = ref(true);
const hasError = ref(false);

const objectivePortfolio = computed(() => {
  return catalog.value?.recommended.portfolios[0];
});

function handleBack() {
  if (useCatalogStore().fromUserFlow) {
    router.push({
      name: useCatalogStore().fromUserFlow,
      query: { cameFrom: useCatalogStore().fromUserCameFrom }
    });
  } else {
    const cameFrom = (route.query?.module as string) || 'wealth';
    router.push({ name: cameFrom });
  }
}

function goToFundsBuilder(type: string, askForInvestorType: boolean) {
  props.routeInvestmentGuard();

  const query = askForInvestorType
    ? { qualifiedInvestor: String(askForInvestorType) }
    : {};

  router.push({
    name: 'fundsAcquisition',
    params: { type },
    query
  });
}

function goToCatalog(tab: string) {
  props.routeInvestmentGuard();

  router.push({
    name: 'catalogBuilder',
    params: {
      type: tab || 'fixed-income',
      cameFrom: 'catalog'
    }
  });
}

function goToVariableIncomeBuilder(id: string) {
  router.push({
    name: 'variableIncomeAcquisition',
    params: { id }
  });
}

async function fetchCatalog() {
  try {
    isLoading.value = true;
    hasError.value = false;

    catalog.value = await getCatalog();
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onBeforeMount(async () => {
  await fetchCatalog();
});

return { __sfc: true,router, route, props, catalog, isLoading, hasError, objectivePortfolio, handleBack, goToFundsBuilder, goToCatalog, goToVariableIncomeBuilder, fetchCatalog, NavBar, LoaderIndicator, HelperViewStatus, Heading, HeadingDisplay, Grid, ButtonBoxDecide, BackButton, ObjectiveCard, WalletCard }
}

})